<template>
  <div class="server-wrap">
    <div class="nav-wrap" v-if="routerType !== 'main'">
      <div class="flex">
        <i class="iconfont icon-home1"></i>
        <router-link class="link" to="/creditServer/main">信用服务</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" :to="$route.path" replace
        ><span>{{ routerTypeName }}</span></router-link
        >
      </div>
    </div>
    <div class="server-bottom">
      <div class="flex flex-wrap link-wrap" v-if="routerType === 'main'">
        <template v-for="item in creditLink">
          <!-- 针对外部链接：使用 a 标签并在新窗口打开 -->
          <a
              v-if="item.link.startsWith('http')"
              :key="item.id"
              class="link-box"
              :href="item.link"
              target="_blank"
              :style="{ 'background-color': item.color, 'display': 'block', 'text-decoration': 'none' }"
          >
            <div class="link-image flex flex-row-center">
              <img :src="item.image" :alt="item.title" srcset=""/>
            </div>
            <div class="link-title">{{ item.title }}</div>
          </a>

          <!-- 针对内部路由：依然使用 router-link -->
          <router-link
              v-else
              tag="div"
              class="link-box"
              :key="item.id"
              :to="item.link"
              :style="{ 'background-color': item.color }"
          >
            <div class="link-image flex flex-row-center">
              <img :src="item.image" :alt="item.title" srcset=""/>
            </div>
            <div class="link-title">{{ item.title }}</div>
          </router-link>
        </template>
      </div>
      <!-- 异议申诉 -->
      <template v-else-if="routerType === 'representation'">
        <div class="representation-wrap">

          <!-- 调整点：将按钮组的 top 设置为 0，使其回到顶部与标题同行 -->
          <div class="button-group" style="position: absolute; right: 0; top: 0; display: flex; gap: 12px; z-index: 10;">
            <el-button type="primary" size="small" plain @click="openContractObjection">合同异议申诉</el-button>
            <el-button type="warning" size="small" plain @click="myRepresent">我的异议</el-button>
          </div>
          <div class="border-5">
            <div class="border-5 active">
              <i class="iconfont icon-bianjiwenjian"></i>异议处理情况列表
            </div>
          </div>
          <div class="wrap-border">
            <ul class="">
              <li class="flex" v-for="item in tableData" :key="item.id">
                <p>{{ item.name }}</p>
                <p>{{ item.mobile | mobileFilter }}</p>
                <p>于{{ item.applytime }}提起了异议</p>
              </li>
            </ul>
            <empty :padding="`34px 0`" v-if="tableData.length === 0"/>
          </div>
        </div>
        <div class="representation-wrap">
          <div class="border-5">
            <div class="border-5 active">
              <i class="iconfont icon-gongzuoliuchengtu"></i>申诉流程
            </div>
          </div>
          <div class="wrap-border flex flex-row-center">
            <div class="">
              <img src="@/static/images/server/7.png" alt="" srcset=""/>
              <p>信息查询</p>
            </div>
            <p>
              <i class="el-icon-arrow-right"></i>
            </p>
            <div class="" style="margin-top: 19px">
              <img src="@/static/images/server/8.png" alt="" srcset=""/>
              <p>异议申请</p>
              <p>(并提交相关证明材料)</p>
            </div>
            <p>
              <i class="el-icon-arrow-right"></i>
            </p>
            <div class="">
              <img src="@/static/images/server/9.png" alt="" srcset=""/>
              <p>异议受理</p>
            </div>
            <p>
              <i class="el-icon-arrow-right"></i>
            </p>
            <div class="">
              <img src="@/static/images/server/10.png" alt="" srcset=""/>
              <p>异议核查</p>
            </div>
            <p>
              <i class="el-icon-arrow-right"></i>
            </p>
            <div class="">
              <img src="@/static/images/server/11.png" alt="" srcset=""/>
              <p>异议回复</p>
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="routerType === 'administrat_find'">
        <div
            class="search-option flex"
            v-if="routerType === 'administrat_find'"
        >
          <div class="position-button" @click="showHandler">
            {{ show ? "收起" : "高级筛选" }}
            <span v-if="deptSelectList.length"
            >({{ deptSelectList.length }})</span
            ><i class="el-icon-d-arrow-right"></i>
          </div>
          <!-- <router-link class="position-button" tag="a" to="/mattersDirectory">事项目录</router-link> -->
        </div>
        <div class="server-title" v-if="routerTypeName">
          {{ routerTypeName }}
        </div>


        <div class="search-section">
          <!-- 第一行：搜索框 -->
          <el-input
              class="server-search"
              v-model="serverWord"
              :placeholder="placeholder"
              clearable
          >
            <el-select
                v-model="select"
                slot="prepend"
                placeholder="请选择"
                v-if="['administrat_find'].includes(routerType)"
                @change="searchSelectChange"
            >
              <el-option label="行政许可" :value="3"></el-option>
              <el-option label="行政处罚" :value="4"></el-option>
            </el-select>
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="creditSearchHandler"
            ></el-button>
          </el-input>

          <!-- 第二行：验证码输入 + 图片 -->
          <div class="captcha-wrap">
            <el-input
                class="yanZhengMa"
                v-model="imageCaptcha"
                placeholder="输入验证码"
            ></el-input>
            <el-image
                :src="imageCode"
                @click="getCaptchaImgHandle"
                class="captcha-image"
                fit="fit"
            ></el-image>
          </div>
        </div>


        <div class="server-condition" v-if="show">
          <div class="flex condition-top">
            <p class="flex-shrink">决定日期</p>
            <el-date-picker
                v-model="date"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            >
            </el-date-picker>
            <div class="condition-button">
              <el-button type="primary" @click="clearHandler">清空</el-button>
              <el-button type="primary" @click="conditionHandler"
              >确定
              </el-button
              >
            </div>
          </div>
          <div class="flex flex-items-start condition-bottom condition-middle">
            <div class="flex-shrink">当前选择</div>
            <div class="flex flex-wrap dept-wrap">
              <div
                  class="condition-dept condition-select"
                  v-for="(item, index) in deptSelectList"
                  :key="index"
              >
                {{ item.fullName }}
                <i class="el-icon-close" @click="deleteDept(index)"></i>
              </div>
            </div>
          </div>
          <div class="flex flex-items-start condition-bottom">
            <div class="flex-shrink">单位</div>
            <div class="flex flex-wrap dept-wrap">
              <div
                  class="condition-dept"
                  v-for="item in deptList"
                  :key="item.id"
                  :style="{
                  color: deptSelectIdList.includes(item.id) ? '#d01c0b' : '',
                }"
                  @click="selectDept(item)"
              >
                {{ item.fullName }}
              </div>
            </div>
          </div>
        </div>
        <!--Table -->
        <ul class="server-table">
          <!-- 失信被执行人 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'break'"
          >
            <p>序号</p>
            <p>被执行人名称</p>
            <!-- 字段待添加 -->
            <p>执行法院</p>
            <P>执行依据文号</P>
            <p>发布时间</p>
            <!-- <p>总失信次数</p> -->
          </li>
          <!-- 行政许可/行政处罚 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'administrat_find'"
          >
            <p>社会主体名称</p>
            <p>决定日期</p>
          </li>
          <!-- 统一社会信用代码公示 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'social_find'"
          >
            <p>企业名称</p>
            <p>统一社会信用代码</p>
            <!-- <p>工商注册号</p> -->
          </li>
          <!-- 企业经营异常名录 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'abnormal_find'"
          >
            <p>企业名称</p>
            <p>工商注册号</p>
          </li>
          <template v-if="tableData.length > 0">
            <li class="" v-for="(item,index) in tableData" :key="item.id">
              <!-- <router-link class="flex flex-row-between" target="_blank" to="" v-if="routerType==='break'"> -->
              <div class="flex flex-row-between" v-if="routerType === 'break'">
                <p>{{ index + 1 }}</p>

                <p>{{ item.name }}</p>
                <!-- 执行法院 -->
                <p>{{ item.executioncourt }}</p>
                <!-- 执行依据文号 -->
                <P>{{ item.executioncaseno }}</P>
                <!-- 发布时间 -->
                <p>{{ item.publishtime.slice(0, 11) }}</p>
                <!-- 失信次数 -->
                <!-- <p>{{ item.grandtotal }}</p> -->
              </div>


              <!-- </router-link> -->
              <router-link
                  class="flex flex-row-between"
                  target="_blank"
                  :to="`/company?number=${item.number}&tab=企业经营异常名录${
                  [2, 4].includes(+item.type) ? '&name=' + item.name : ''
                }`"
                  v-if="routerType === 'abnormal_find'"
              >
                <p>{{ item.name }}</p>
                <p>{{ item.number }}</p>
              </router-link>
              <router-link
                  class="flex flex-row-between"
                  target="_blank"
                  :to="`/company?number=${item.number}&tab=${
                  select == 3 ? '行政许可' : '行政处罚'
                }${[2, 4].includes(+item.type) ? '&name=' + item.name : ''}`"
                  v-if="routerType === 'administrat_find'"
              >
                <p>{{ item.name }}</p>
                <p>{{ item.decisionDate | timeFilter }}</p>
              </router-link>
              <router-link
                  class="flex flex-row-between"
                  :to="`/company?number=${item.number}&tab=信息概览`"
                  v-if="routerType === 'social_find'"
              >
                <p>{{ item.name }}</p>
                <p>{{ item.number }}</p>
                <!-- <p></p> -->
              </router-link>
            </li>
          </template>
          <empty v-else/>
        </ul>
        <div class="flex flex-row-end pagination-wrap">
          <el-pagination
              background
              layout="total, prev, pager, next"
              :pageSize="pageSize"
              :total="total"
              @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </template>

      <template v-else>
        <div
            class="search-option flex"
            v-if="routerType === 'administrat_find'"
        >
          <div class="position-button" @click="showHandler">
            {{ show ? "收起" : "高级筛选" }}
            <span v-if="deptSelectList.length"
            >({{ deptSelectList.length }})</span
            ><i class="el-icon-d-arrow-right"></i>
          </div>
          <!-- <router-link class="position-button" tag="a" to="/mattersDirectory">事项目录</router-link> -->
        </div>
        <div class="server-title" v-if="routerTypeName">
          {{ routerTypeName }}
        </div>


        <div class="search-section">
          <!-- 第一行：搜索框 -->
          <el-input
              class="server-search"
              v-model="serverWord"
              :placeholder="placeholder"
              clearable
          >
            <el-select
                v-model="select"
                slot="prepend"
                placeholder="请选择"
                v-if="['administrat_find'].includes(routerType)"
                @change="searchSelectChange"
            >
              <el-option label="行政许可" :value="3"></el-option>
              <el-option label="行政处罚" :value="4"></el-option>
            </el-select>
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="creditSearchHandler"
            ></el-button>
          </el-input>

          <!--          &lt;!&ndash; 第二行：验证码输入 + 图片 &ndash;&gt;-->
          <!--          <div class="captcha-wrap">-->
          <!--            <el-input-->
          <!--                class="yanZhengMa"-->
          <!--                v-model="imageCaptcha"-->
          <!--                placeholder="输入验证码"-->
          <!--            ></el-input>-->
          <!--            <el-image-->
          <!--                :src="imageCode"-->
          <!--                @click="getCaptchaImgHandle"-->
          <!--                class="captcha-image"-->
          <!--                fit="fit"-->
          <!--            ></el-image>-->
          <!--          </div>-->
        </div>


        <div class="server-condition" v-if="show">
          <div class="flex condition-top">
            <p class="flex-shrink">决定日期</p>
            <el-date-picker
                v-model="date"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            >
            </el-date-picker>
            <div class="condition-button">
              <el-button type="primary" @click="clearHandler">清空</el-button>
              <el-button type="primary" @click="conditionHandler"
              >确定
              </el-button
              >
            </div>
          </div>
          <div class="flex flex-items-start condition-bottom condition-middle">
            <div class="flex-shrink">当前选择</div>
            <div class="flex flex-wrap dept-wrap">
              <div
                  class="condition-dept condition-select"
                  v-for="(item, index) in deptSelectList"
                  :key="index"
              >
                {{ item.fullName }}
                <i class="el-icon-close" @click="deleteDept(index)"></i>
              </div>
            </div>
          </div>
          <div class="flex flex-items-start condition-bottom">
            <div class="flex-shrink">单位</div>
            <div class="flex flex-wrap dept-wrap">
              <div
                  class="condition-dept"
                  v-for="item in deptList"
                  :key="item.id"
                  :style="{
                  color: deptSelectIdList.includes(item.id) ? '#d01c0b' : '',
                }"
                  @click="selectDept(item)"
              >
                {{ item.fullName }}
              </div>
            </div>
          </div>
        </div>
        <!--Table -->
        <ul class="server-table">
          <!-- 失信被执行人 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'break'"
          >
            <p>序号</p>
            <p>被执行人名称</p>
            <!-- 字段待添加 -->
            <p>执行法院</p>
            <P>执行依据文号</P>
            <p>发布时间</p>
            <!-- <p>总失信次数</p> -->
          </li>
          <!-- 行政许可/行政处罚 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'administrat_find'"
          >
            <p>社会主体名称</p>
            <p>决定日期</p>
          </li>
          <!-- 统一社会信用代码公示 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'social_find'"
          >
            <p>企业名称</p>
            <p>统一社会信用代码</p>
            <!-- <p>工商注册号</p> -->
          </li>
          <!-- 企业经营异常名录 -->
          <li
              class="flex flex-row-between table-header"
              v-if="routerType === 'abnormal_find'"
          >
            <p>企业名称</p>
            <p>工商注册号</p>
          </li>
          <template v-if="tableData.length > 0">
            <li class="" v-for="(item,index) in tableData" :key="item.id">
              <!-- <router-link class="flex flex-row-between" target="_blank" to="" v-if="routerType==='break'"> -->
              <div class="flex flex-row-between" v-if="routerType === 'break'">
                <p>{{ index + 1 }}</p>
                <!-- <p>
                  <el-button
                    type="text"
                    style="color: #2c3e50"
                    @click="dialogVisible(record)"
                    >{{ item.name }}</el-button
                  >
                </p> -->
                <p>{{ item.name }}</p>
                <!-- 执行法院 -->
                <p>{{ item.executioncourt }}</p>
                <!-- 执行依据文号 -->
                <P>{{ item.executioncaseno }}</P>
                <!-- 发布时间 -->
                <p>{{ item.publishtime.slice(0, 11) }}</p>
                <!-- 失信次数 -->
                <!-- <p>{{ item.grandtotal }}</p> -->
              </div>
              <!-- <el-dialog
                title="提示"
                :visible.sync="centerDialogVisible"
                width="30%"
                center
              >
                <el-descriptions :column="1" border>
                  <el-descriptions-item>
                    <template slot="label"> 失信被执行人名称 </template>
                    <p>{{}}</p>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 执行依据文号 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 发布时间 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 作出执行依据单位 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 地域名称 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 执行法院 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 被执行人的履行情况 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 企业法人姓名 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 法律生效文书确定的义务 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 案号 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 未履行部分 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 已履行部分 </template>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 立案时间 </template>
                  </el-descriptions-item>
                </el-descriptions>
              </el-dialog> -->

              <!-- </router-link> -->
              <router-link
                  class="flex flex-row-between"
                  target="_blank"
                  :to="`/company?number=${item.number}&tab=企业经营异常名录${
                  [2, 4].includes(+item.type) ? '&name=' + item.name : ''
                }`"
                  v-if="routerType === 'abnormal_find'"
              >
                <p>{{ item.name }}</p>
                <p>{{ item.number }}</p>
              </router-link>
              <router-link
                  class="flex flex-row-between"
                  target="_blank"
                  :to="`/company?number=${item.number}&tab=${
                  select == 3 ? '行政许可' : '行政处罚'
                }${[2, 4].includes(+item.type) ? '&name=' + item.name : ''}`"
                  v-if="routerType === 'administrat_find'"
              >
                <p>{{ item.name }}</p>
                <p>{{ item.decisionDate | timeFilter }}</p>
              </router-link>
              <router-link
                  class="flex flex-row-between"
                  :to="`/company?number=${item.number}&tab=信息概览`"
                  v-if="routerType === 'social_find'"
              >
                <p>{{ item.name }}</p>
                <p>{{ item.number }}</p>
                <!-- <p></p> -->
              </router-link>
            </li>
          </template>
          <empty v-else/>
        </ul>
        <div class="flex flex-row-end pagination-wrap">
          <el-pagination
              background
              layout="total, prev, pager, next"
              :pageSize="pageSize"
              :total="total"
              @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </template>
    </div>

    <!-- 新增：合同异议申诉弹窗 -->
    <el-dialog
        title="合同异议申诉"
        :visible.sync="contractDialogVisible"
        width="620px"
        custom-class="custom-contract-dialog"
        :close-on-click-modal="false"
    >
      <el-form
          ref="contractForm"
          :model="formData"
          label-width="88px"
          label-position="right"
          :rules="rules"
          class="contract-form"
          size="medium"
      >
        <el-form-item label="主体类型" prop="type">
          <el-select v-model="formData.type" placeholder="请选择主体类型" style="width: 100%;">
            <el-option label="法人" value="法人"></el-option>
            <el-option label="自然人" value="自然人"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="name" label="主体名称">
          <el-input v-model="formData.name" placeholder="请输入主体名称" clearable></el-input>
        </el-form-item>

        <el-form-item prop="number" label="编号/名称">
          <el-input v-model="formData.number" placeholder="请输入合同编号/名称" clearable></el-input>
        </el-form-item>

        <el-form-item label="申诉类型" prop="appealtype">
          <el-select v-model="formData.appealtype" placeholder="请选择申诉类型" style="width: 100%;">
            <el-option v-for="item in appealTypeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="mobile" label="联系电话">
          <el-input v-model="formData.mobile" placeholder="请输入11位联系电话" maxlength="11" clearable></el-input>
        </el-form-item>

        <el-form-item prop="description" label="描述">
          <el-input
              type="textarea"
              v-model="formData.description"
              placeholder="请输入描述详情"
              :rows="4"
              resize="none"
              show-word-limit
              maxlength="300"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
    <el-button @click="contractDialogVisible = false" size="medium">取 消</el-button>
    <el-button type="primary" @click="confirmContractSubmit" size="medium">确 认 提 交</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {CREDITLINKLIST, CREDITTYPE} from "@/utils/creditServer";

import {abnormalList, appealsList, bothPublic, getOrganization, losePeople, searchEnterprise,creditObjectionAppeals} from "@/api";

import empty from "@/components/empty";
import BASE_URL from "@/api/base";
import {v4 as uuidv4} from 'uuid'



export default {
  components: {
    empty,
  },
  data() {
    return {
      routerType: "main",
      serverWord: undefined,
      select: undefined,
      creditLink: CREDITLINKLIST,
      tableData: [],
      total: 0,
      pageSize: 15,
      deptList: [],
      show: false,
      date: [],
      deptSelectList: [],
      centerDialogVisible: false,
      imageCode: undefined,
      uuid: undefined,
      imageCaptcha: undefined,
      contractDialogVisible: false,
      action: BASE_URL + '/api/file/upload', // 确保已经引入了 BASE_URL
      appealTypeList: [
        { id: 6, label: '合同履约' },
      ],
      fileList1: [],
      formData: {
        type: '',
        name: '',
        number: '', // 现代表合同编号
        description: '',
        appealtype: '',
        mobile: '',
        dataid: '',
        replydescription: '',
        replyfile: '',
        file1: null
      },
      rules: {
        type: [{ required: true, message: '请选择主体类型', trigger: 'change' }],
        name: [{ required: true, message: '请填写主体名称', trigger: 'blur' }],
        number: [{ required: true, message: '请填写合同编号', trigger: 'blur' }],
        description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
        appealtype: [{ required: true, message: '请选择修复类型', trigger: 'change' }],
        mobile: [{ required: true, message: '请填写联系电话', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.$set(this, "select", undefined);


  },
  mounted() {

    this.getCaptchaImgHandle()
  },
  methods: {
    // --- 新增：合同异议方法 ---
    openContractObjection() {
      // 打开弹窗前可根据需要做登录拦截（如：if(!this.$store.state.token) return ...）
      this.contractDialogVisible = true;
      if ( this.formData.dataid== ''){
        this.formData.dataid = this.formData.number;
      }

      this.$nextTick(() => {
        // 每次打开清空表单及上传列表
        if (this.$refs.contractForm) {
          this.$refs.contractForm.resetFields();
        }
        this.fileList1 = [];
        // this.$set(this.formData, 'file1', null);
        // 可选：默认选中某个申诉类型
        this.$set(this.formData, 'appealtype', 6);
      });
    },

    // 上传相关回调（针对弹窗中的单文件材料一）
    handleRemove(file, fileList) {
      this.$set(this.formData, 'file1', null);
      this.fileList1 = fileList;
    },
    handlePreview(file) {
      console.log('预览文件:', file);
    },
    beforeUpload(file) {
      // 可以在此处校验文件大小、格式等
      return true;
    },
    onSuccess(response, file, fileList) {
      const { name } = file;
      const { result } = response;
      // 记录上传成功后的信息
      this.$set(this.formData, 'file1', { url: result, name });
      this.fileList1 = fileList.slice(-1); // 如果只能传一份，可截取最新的一份
    },
    onError(err, file, fileList) {
      this.$message.error('文件上传失败');
    },

    // 确认提交
    confirmContractSubmit() {
      this.$refs['contractForm'].validate((valid) => {
        if (valid) {
          // if (!this.formData.file1) {
          //   return this.$message({ type: 'warning', message: '请上传材料一' });
          // }

          // 1. 拷贝一份表单数据，防止直接修改 formData 导致页面显示异常
          const submitData = { ...this.formData };

          // 2. 将文件对象处理为后端通常需要的 URL 字符串
          // 之前存的是 { url: result, name }，这里提取出 url 传给后端
          if (submitData.file1 && typeof submitData.file1 === 'object') {
            submitData.file1 = submitData.file1.url;
          }
          // TODO: 调用后端提交接口
          console.log('即将提交的表单数据:', this.formData);
          // creditRepairs(this.formData).then(res => {
          //   this.$message.success('提交成功，请等待审核');
          //   this.contractDialogVisible = false;
          // });
          // 3. 调用真实接口
          creditObjectionAppeals(submitData).then(res => {
            this.$message.success('申诉提交成功，请等待审核');
            this.contractDialogVisible = false; // 关闭弹窗

            // 提交成功后重新获取列表数据，刷新当前页面显示
            this.getData();
          }).catch(err => {
            // 如果请求失败可以在这里补充逻辑，一般 request.js 拦截器里会有全局错误提示
            console.error('提交失败:', err);
          });

        } else {
          console.log('表单校验未通过');
          return false;
        }
      });
    },
    creditSearchHandler() {
      this.getData();
    },
    handleCurrentChange(e) {
      console.log(e);
      this.getData(e);
    },
    getCaptchaImgHandle() {
      let uuid = uuidv4()
      this.uuid = uuid
      this.imageCode = BASE_URL + `/api/captcha/image?token=${this.uuid}`
    },
    getData(page = 1) {
      switch (this.routerType) {
        case "social_find": //统一社会信用代码公示查询--暂无数据
          this.getSearchEnterprise(page);
          break;
        case "break": //失信被执行人查询--暂无接口
          this.getBreak(page);
          break;
        case "administrat_find": //行政许可/行政处罚查询
          this.getPublicList(page);
          break;
        case "abnormal_find": //企业经营异常名录查询
          this.getAbnormal(page);
          break;
        case "representation":
          this.getAppeals(page);
          break;
        default:
          break;
      }
    },
    searchSelectChange(e) {
      if (e > 2) {
        this.getPublicList(1);
      } else {
        this.getBreak(1);
      }
    },
    // 失信
    getBreak(page = 1) {
      const params = {
        current: page,
        type: this.select === 2 ? "自然人" : "法人",
      };
      if (this.serverWord) {
        params.keyword = this.serverWord;
      }
      losePeople(params).then((res) => {
        this.setTableData(res);
      });
    },
    dialogVisible(record) {
      console.log(record);
      centerDialogVisible = true;
    },

    // 行政许可、行政处罚
    getPublicList(page = 1) {

      const params = {
        current: page,
      };

      if (this.serverWord) {
        params.keyword = this.serverWord;
      }
      if (Array.isArray(this.date) && this.date.length === 2) {
        params.decisionStartDate = this.date[0];
        params.decisionEndDate = this.date[1];
      }
      if (this.deptSelectIdList.length > 0) {
        params.orgIds = this.deptSelectIdList.join(",");
      }
      params.routerType = this.routerType;
      params.types =
          [3, 4].includes(this.select) && this.select === 3 ? "1,2" : "3,4";
      console.log("this.imageCaptcha"+this.imageCaptcha)
      console.log("this.uuid"+this.uuid)
      if (this.imageCaptcha) {
        params.imageCaptcha = this.imageCaptcha
        params.imageToken = this.uuid
      }
      bothPublic(params).then((res) => {
        this.setTableData(res);
      });
    },
    setTableData(response) {
      const {records, size, current, total} = response;
      this.$set(this, "total", total || 0);
      this.$set(this, "pageSize", size || 15);
      this.$set(this, "tableData", records || []);
    },
    getSearchEnterprise(page = 1) {
      searchEnterprise({
        current: page,
        keyword: this.serverWord,
        type: 2,
      }).then((res) => {
        // searchEnterprise({ page, keyword: this.serverWord, type: this.select }).then(res => {
        this.setTableData(res);
      });
    },
    // 企业经营异常名录查询
    getAbnormal(page = 1) {
      abnormalList({current: page, keyword: this.serverWord}).then((res) => {
        this.setTableData(res);
      });
    },
    // 异议申诉
    getAppeals(page) {
      appealsList({current: page}).then((res) => {
        this.setTableData(res);
      });
    },

    myRepresent() {
      this.$router.push(`/user/myappeal`);
    },
    showHandler() {
      this.show = !this.show;
      if (this.show) {
        this.getDepartment();
      }
    },
    // 获取组织
    getDepartment() {
      getOrganization().then((res) => {
        this.$set(this, "deptList", res);
      });
    },
    selectDept(row) {
      if (this.deptSelectIdList.includes(row.id)) {
        this.$set(
            this,
            "deptSelectList",
            this.deptSelectList.filter((item) => item.id !== row.id)
        );
      } else {
        this.$set(this, "deptSelectList", [...this.deptSelectList, row]);
      }
    },
    deleteDept(index) {
      this.deptSelectList.splice(index, 1);
    },
    // 高级筛选-确定
    conditionHandler() {
      this.show = false;
      if (this.routerType === "administrat_find") {
        this.getPublicList(1);
      }
    },
    // 高级筛选-清空
    clearHandler() {
      this.$set(this, "date", []);
      this.$set(this, "deptSelectList", []);
      this.show = false;
      if (this.routerType === "administrat_find") {
        this.getPublicList(1);
      }
    },
  },
  computed: {
    routerTypeName() {
      if (this.routerType === "main") {
        return "";
      } else if (this.routerType === "representation") {
        return "异议申诉";
      } else {
        return (CREDITTYPE.find((item) => item.id === this.routerType) || {})
            .name;
      }
    },
    placeholder() {
      if (this.routerTypeName) {
        return (CREDITTYPE.find((item) => item.id === this.routerType) || {})
            .placeholder;
      }
    },
    deptSelectIdList({deptSelectList}) {
      if (deptSelectList.length > 0) {
        return deptSelectList.map((item) => item.id);
      } else {
        return [];
      }
    },
  },
  watch: {
    $route: {
      handler(v) {
        const {
          params: {type},
        } = v;
        this.$nextTick(function () {
          this.$set(this, "routerType", type);
          // 需要处理刷新页面丢失select选中状态
          if (type === "break") {
            this.$set(this, "select", 1);
          }
          if (type === "administrat_find") {
            this.$set(this, "select", 3);
          }
          this.getData();

          // this.getData();
          // 【修改点 1】：拦截进入行政许可/处罚页面的初始查询
          if (type === 'administrat_find') {
            // 一进页面不查，初始化为空状态
            this.tableData = [];
            this.total = 0;
          } else {
            // 其他页面保持原有逻辑，进页面就查
            this.getData();
          }
        });
      },
      deep: true,
      immediate: true,
    },
    select(v, oldV) {
      if (v && oldV && v !== oldV) {
        if (v < 3) {
        } else {
          this.getPublicList(1);
// 【修改点 2】：防止切换下拉框时自动查询，将其注释或删除
          // this.getPublicList(1);

          // 切换选项时清空旧数据，等待用户手动点击查询
          this.tableData = [];
          this.total = 0;
        }
      }
    },
  },
  filters: {
    timeFilter(time) {
      if (time) {
        return time.slice(0, 10);
      } else {
        return "";
      }
    },
    mobileFilter(str) {
      if (str) {
        const str2 = str.toString();
        return str2.slice(0, 3) + "****" + str2.slice(8);
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss">
$red: #d11d0f;

/* =========================================================
 * 合同异议申诉弹窗
 * ---------------------------------------------------------
 * 设计目标：
 * 1. 弹窗宽度固定，避免内容撑开
 * 2. 表单左右留出合理内边距
 * 3. 输入框不突破弹窗边界
 * 4. 输入内容时页面不会发生横向偏移
 * 5. Label 与输入框保持统一间距
 * 6. 兼容 Element UI 2.x
 * ========================================================= */
.custom-contract-dialog {
  width: 620px;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.16);

  /* =========================
   * 弹窗头部
   * ========================= */
  .el-dialog__header {
    height: 58px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #eeeeee;

    .el-dialog__title {
      font-size: 17px;
      font-weight: 600;
      color: #333333;
      line-height: 58px;
    }

    .el-dialog__headerbtn {
      top: 20px;
      right: 22px;

      .el-dialog__close {
        font-size: 18px;
        color: #999999;

        &:hover {
          color: #666666;
        }
      }
    }
  }

  /* =========================
   * 弹窗主体
   * ========================= */
  .el-dialog__body {
    padding: 24px 32px 8px;
    box-sizing: border-box;
  }

  /* =========================
   * 表单整体
   * ========================= */
  .contract-form {
    width: 100%;
    box-sizing: border-box;

    /* 每一项统一高度和间距 */
    .el-form-item {
      width: 100%;
      margin-bottom: 18px;
      box-sizing: border-box;

      &:last-child {
        margin-bottom: 8px;
      }
    }

    /* Label */
    .el-form-item__label {
      width: 88px !important;
      padding-right: 14px;
      box-sizing: border-box;

      color: #555555;
      font-size: 14px;
      font-weight: 400;
      line-height: 36px;
    }

    /* =====================================================
     * 核心修复
     *
     * Element UI 默认：
     *
     * .el-form-item__content {
     *   margin-left: xxx;
     * }
     *
     * 如果项目其他地方存在 width: 100%，
     * 就会造成：
     *
     * Label + Content > Dialog
     *
     * 最终表现为：
     * - 输入框特别长
     * - 输入框突破右边界
     * - 输入内容后出现横向位移
     * ===================================================== */
    .el-form-item__content {
      margin-left: 88px !important;
      width: calc(100% - 88px) !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
      line-height: normal;
    }

    /* =========================
     * 普通输入框
     * ========================= */
    .el-input {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }

    .el-input__inner {
      width: 100% !important;
      max-width: 100% !important;
      height: 36px !important;
      line-height: 36px !important;

      padding: 0 12px !important;

      border: 1px solid #dcdfe6 !important;
      border-radius: 4px !important;

      background-color: #ffffff !important;

      color: #333333;
      font-size: 14px;

      box-sizing: border-box !important;

      /* 防止输入内容导致尺寸重新计算 */
      min-width: 0 !important;

      &:focus {
        border-color: #409eff !important;
        outline: none;
      }

      &::placeholder {
        color: #c0c4cc;
      }
    }

    /* =========================
     * 下拉选择框
     * ========================= */
    .el-select {
      width: 100% !important;
      max-width: 100% !important;
      display: block;
      box-sizing: border-box !important;
    }

    .el-select .el-input {
      width: 100% !important;
    }

    .el-select .el-input__inner {
      width: 100% !important;
    }

    /* =========================
     * 文本域
     * ========================= */
    .el-textarea {
      width: 100% !important;
      max-width: 100% !important;
      display: block;
      box-sizing: border-box !important;
    }

    .el-textarea__inner {
      width: 100% !important;
      max-width: 100% !important;

      min-height: 92px !important;

      padding: 10px 12px !important;

      border: 1px solid #dcdfe6 !important;
      border-radius: 4px !important;

      background-color: #ffffff !important;

      color: #333333;
      font-size: 14px;
      line-height: 22px;

      resize: none !important;

      box-sizing: border-box !important;

      &:focus {
        border-color: #409eff !important;
        outline: none;
      }

      &::placeholder {
        color: #c0c4cc;
      }
    }

    /* =========================
     * 字数统计
     * ========================= */
    .el-input__count {
      background: transparent !important;
      color: #999999;
      right: 10px;
      bottom: 5px;
    }

    /* =========================
     * 校验错误状态
     * ========================= */
    .el-form-item.is-error {
      .el-input__inner,
      .el-textarea__inner {
        border-color: #f56c6c !important;
      }
    }

    /* =========================
     * 错误提示
     * ========================= */
    .el-form-item__error {
      padding-top: 4px;
      font-size: 12px;
      line-height: 16px;
    }
  }

  /* =========================
   * 底部按钮区域
   * ========================= */
  .el-dialog__footer {
    padding: 16px 32px;
    box-sizing: border-box;

    background-color: #fafafa;
    border-top: 1px solid #eeeeee;

    text-align: right;

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 12px;
    }

    .el-button {
      min-width: 78px;
      height: 36px;
      padding: 0 18px;

      border-radius: 4px;
      box-sizing: border-box;

      font-size: 14px;

      & + .el-button {
        margin-left: 0;
      }
    }

    .el-button--primary {
      min-width: 114px;
    }
  }
}

/* 外层容器：整体居中 */
.search-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

/* 搜索框：固定宽度，居中 */
.server-search {
  width: 600px;
}

/* 验证码区域：固定宽度，靠右对齐 */
.captcha-wrap {
  width: 600px; /* 与 .server-search 一致 */
  display: flex;
  justify-content: flex-end; /* 🔸 关键：靠右对齐 */
  align-items: center;
  gap: 10px;
}

/* 验证码输入框 */
.yanZhengMa {
  width: 200px;
}

/* 验证码图片 */
.captcha-image {
  width: 80px;
  height: 40px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.server-wrap {
  .server-bottom {
    width: 1280px;
    margin: 0 auto;
    padding: 15px 0;
    position: relative;
    text-align: center;

    .server-title {
      padding-top: 50px;
      line-height: 64px;
      font-size: 18px;
      color: $red;
      text-align: center;
      font-weight: bold;
    }

    .link-wrap {
      padding-top: 70px;

      .link-box {
        flex-basis: 23.5%;
        border-radius: 6px;
        margin-bottom: 60px;
        overflow: hidden;
        cursor: pointer;
        margin-right: 2%;

        &:nth-child(4n) {
          margin: 0 0 60px;
        }

        .link-image {
          height: 180px;
          opacity: 0.5;
        }

        .link-title {
          height: 50px;
          font-size: 16px;
          text-align: center;
          word-break: keep-all;
          z-index: 9;
          line-height: 50px;
          background-color: #eee;
          color: #333;
          font-weight: 700;
        }

        &:hover {
          .link-image {
            opacity: 1;
          }
        }
      }
    }

    .server-search {
      width: 590px;

      .el-input-group__prepend {
        padding: 0 15px;
        width: 25%;
        flex-shrink: 0;
        border: 1px solid $red;
        border-right: none;
        background-color: #fff;

        .el-select {
          width: 100%;

          .el-input {
            width: 100%;
          }
        }
      }
    }

    .representation-wrap {
      position: relative;
      text-align: center;

      .flex {
        p {
          flex: 1;
          line-height: 50px;
        }
      }

      & + .representation-wrap {
        margin-top: 20px;
      }

      .active {
        width: 15%;
        padding: 0;
        text-align: left;

        & > i {
          color: $red;
          font-size: 24px;
          font-weight: bold;
          margin-right: 4px;
        }

        & + .el-button {
          position: absolute;
          top: 10px;
          right: 0;
        }
      }

      & > .wrap-border {
        min-height: 250px;

        & > p {
          width: 130px;
          height: 3px;
          background-color: #fad1d1;
          position: relative;

          & > i {
            color: #fff;
            font-size: 13px;
            display: block;
            width: 18px;
            height: 19px;
            background-color: $red;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 5px;
            left: 50%;
            transform: translate(-50%, -12px);
          }
        }
      }
    }

    .server-table {
      width: 995px;
      margin: 0 auto;
      margin-top: 40px;

      & > .table-header {
        background-color: #f4f4f4;
        border-bottom: 1px solid #e0e7ed;
      }

      & > li {
        padding: 14px 8px;
        line-height: 2;

        p {
          text-align: center;
          flex: 1;
        }

        &:nth-child(even) {
          background-color: #fff;
        }
      }
    }

    .pagination-wrap {
      margin: 40px auto 20px;
      width: 995px;
    }

    .search-option {
      position: absolute;
      right: 140px;
      top: 160px;

      .position-button {
        cursor: pointer;
        color: $red;
        text-decoration: underline;

        & + .position-button {
          margin-left: 20px;
        }
      }
    }

    .server-condition {
      width: 995px;
      margin: 20px auto;
      background-color: #fff;
      padding: 20px;

      .flex-shrink {
        color: #aaa;
      }

      .condition-top {
        padding-left: 60px;

        .flex-shrink {
          margin-right: 20px;
        }

        .condition-button {
          flex-grow: 2;
          text-align: right;
          margin-left: 20px;

          & > .el-button {
            background-color: $red;
            border-color: $red;
          }
        }
      }

      .condition-bottom {
        padding: 15px 60px 35px;

        .dept-wrap {
          & > .condition-dept {
            width: 200px;
            line-height: 30px;
            padding: 4px;
            text-align: center;
            cursor: pointer;
          }
        }
      }

      .condition-middle {
        border-bottom: 2px solid #545454;
        padding-bottom: 10px;

        .dept-wrap {
          & > .condition-dept {
            width: auto;
            color: #d01c0b;
            border: 1px solid #d01c0b;
            border-radius: 4px;
            text-align: center;
            margin: 0 15px 15px;
          }
        }
      }
    }
  }
}
</style>

